import React, { HTMLAttributes } from 'react'
import { ChevronRight } from 'react-feather'

import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'

import { FallbackLetterImage } from './fallback-letter-image'

type Props = {
  name: string
  detail?: string
  imageUrl?: string
  showImage?: boolean
  isHoverable?: boolean
  className?: HTMLAttributes<HTMLElement>['className']
  handleSelect: () => void
}

export function SearchResult({
  name,
  detail,
  imageUrl,
  showImage = true,
  isHoverable = true,
  className,
  handleSelect,
}: Props) {
  return (
    <div
      tabIndex={0}
      className={cn(
        'group flex items-center justify-between',
        isHoverable && 'transition-all hover:cursor-pointer hover:bg-electric-100',
        className
      )}
      onClick={handleSelect}
      onKeyDown={(e) => e.key === 'Enter' && handleSelect()}
      data-cy={DataAttribute.UNIFIED_SEARCH_LINK}
    >
      <div className={'flex items-center px-2 text-moss-700'}>
        {imageUrl && showImage && (
          <img
            src={imageUrl}
            className="h-[42px] w-[42px] rounded-full"
            alt={`${name} Logo`}
            role="presentation"
            aria-hidden="true"
          />
        )}
        {!imageUrl && showImage && <FallbackLetterImage letter={name[0]} />}
        <div className="flex flex-col">
          <div
            className={cn(
              showImage && 'ml-3',
              detail && 'text-electric-650',
              isHoverable && 'group-hover:font-semibold'
            )}
            data-cy={DataAttribute.UNIFIED_SEARCH_LINK_NAME}
          >
            {name}
          </div>
          {detail && (
            <div className={cn(showImage && 'ml-3', 'text-sm')} data-cy={DataAttribute.UNIFIED_SEARCH_LINK_DETAIL}>
              {detail}
            </div>
          )}
        </div>
      </div>
      <ChevronRight size={16} className="block text-mint-900" />
    </div>
  )
}
